import { IEnvironmentRegex } from '../types';

const phoneNumberRegex = /^(\+36)? ?\d{9}$/i;
const phoneNumberWithPrefixRegex = /^(\+36) ?\d{9}$/i;
const phoneNumberOnlyWithPrefixRegex = /^(\+36) ?\d{9}$/i;

export const HuEnvironmentRegex: IEnvironmentRegex = {
  phoneNumberRegex,
  phoneNumberWithPrefixRegex,
  phoneNumberOnlyWithPrefixRegex
};
